// 260 frases originales (52 semanas × 5 días laborables) — Suntelco
// Pensadas para instaladores fotovoltaicos: sol, energía, oficio, equipo, calidad.
export const DAILY_PHRASES = [
  "El sol no descansa, pero tu calidad sí marca la diferencia.",
  "Cada panel que conectas es un futuro que enciendes.",
  "Hoy convertimos luz en electricidad, y esfuerzo en orgullo.",
  "La energía que instalas hoy iluminará casas mañana.",
  "Trabajar con el sol es trabajar para siempre.",
  "Donde tú pones tu mano, el sol pone su fuerza.",
  "Sin tu trabajo, los paneles solo son cristal.",
  "Eres puente entre el sol y la red.",
  "La luz no llega sola: la llevamos nosotros.",
  "Cada kilovatio cuenta. Y tú los haces posibles.",
  "Hoy plantamos paneles, mañana cosechamos energía.",
  "Cuanto más limpio el cable, más limpia la energía.",
  "Eres parte de una revolución silenciosa: la del sol.",
  "El planeta respira mejor gracias a manos como las tuyas.",
  "Que cada panel hable bien de tu trabajo.",
  "La buena energía empieza por una buena instalación.",
  "Hoy no instalas paneles: instalas independencia.",
  "Tu obra de hoy ahorra carbono durante veinticinco años.",
  "El sol da gratis lo que tú haces útil.",
  "Un panel mal conectado no produce. Uno bien conectado libera.",
  "Lo que haces hoy se ve en la factura de mañana.",
  "Cuando todo brilla, tú ya hiciste tu parte.",
  "El amanecer es tu jornada: aprovéchalo bien.",
  "Suntelco enciende Lanzarote, uno a uno.",
  "Donde el sol llega, también llega tu trabajo.",
  "La electricidad limpia se siente, pero se hace con sudor.",
  "La fotovoltaica solo funciona con manos como las tuyas.",
  "Un buen sistema no se ve, pero se nota durante años.",
  "Cada vatio que sube a la red lleva tu firma.",
  "Hoy no llueve. Hoy producimos más.",
  "El sol es tu mejor compañero de jornada.",
  "Eres el último eslabón entre el sol y un hogar.",
  "La energía verde se construye un tornillo a la vez.",
  "Producir energía limpia es el oficio más honesto.",
  "Hoy haces algo que beneficiará a personas que no conoces.",
  "Un buen inversor merece una buena instalación.",
  "Cuanto más justo el bridado, más larga la vida del panel.",
  "Cada conexión bien hecha es un kWh más.",
  "Tú no instalas placas; instalas autonomía.",
  "La transición energética empieza en tus manos.",
  "Lo que el sol regala, nosotros lo organizamos.",
  "Para que la luz llegue, alguien tiene que subir al tejado.",
  "Sin operarios, los paneles serían arte abstracto.",
  "La energía del futuro pasa por tu destornillador hoy.",
  "El sol no necesita jefe, solo gente que sepa lo que hace.",
  "Cuanto mejor lo hagas, menos vuelve a romperse.",
  "La estabilidad de la red depende de detalles que solo tú ves.",
  "El sol entrega energía. Tú entregas calidad.",
  "Una conexión correcta evita visitas que nadie quiere repetir.",
  "Lo que parece sencillo, lo haces fácil porque sabes hacerlo.",
  "La obra avanza al ritmo del que más se preocupa.",
  "Un compañero bien apoyado vale el doble.",
  "Pregunta. Es la mejor herramienta del equipo.",
  "La furgoneta es tu segunda casa: cuídala como tal.",
  "El que avisa de un riesgo, salva al de al lado.",
  "Tu seguridad hoy es alegría de tu familia esta noche.",
  "Trabajar en equipo es repartir el peso, no la calidad.",
  "Una broma a tiempo aligera la mejor escalera.",
  "Si dudas, para. Y consúltalo. Hoy y siempre.",
  "Cada operario lleva una historia. Cuídala.",
  "Cuando uno enseña, dos aprenden.",
  "Una buena obra empieza con un buen café compartido.",
  "Apoyar al compañero es construir mejor empresa.",
  "Las prisas no entran en este oficio.",
  "El silencio del experto vale más que mil palabras.",
  "Lo mejor de la jornada: bajar del tejado sano y satisfecho.",
  "El que recoge primero ayuda al que llega después.",
  "Trabajar acompañado es trabajar mejor.",
  "Un buen compañero te hace mejor profesional.",
  "Cuanto más limpio el coche, más respeto al cliente.",
  "La obra es de todos. La calidad también.",
  "Tu paciencia con el nuevo es tu mejor lección.",
  "El equipo brilla cuando todos cuidan los detalles.",
  "Hoy enseñas a alguien algo, aunque no lo sepas.",
  "Confía en tu compañero, pero verifica lo crítico.",
  "Donde uno duda, dos resuelven.",
  "La cuadrilla que ríe, también rinde.",
  "Un saludo al cliente vale tanto como un buen acabado.",
  "El respeto al taller se nota al volver mañana.",
  "Cada herramienta tiene su sitio, como cada operario tiene el suyo.",
  "Compartir el coche es compartir la jornada.",
  "Trabajar de pie, juntos, suma.",
  "La buena fama del equipo se construye día a día.",
  "Una mano amiga ahorra horas de trabajo solo.",
  "Hablar antes de actuar evita rehacer después.",
  "Nadie es imprescindible, pero todos somos necesarios.",
  "Llegar puntual es respetar al equipo.",
  "Avisa pronto si algo no cuadra. Es la regla de oro.",
  "Una comida juntos suelda más que mil reuniones.",
  "Hoy alguien aprende de cómo trabajas. Que merezca la pena.",
  "Cuanto más claro hablas, mejor entiende el equipo.",
  "Una pregunta tonta evita un fallo grande.",
  "Levanta la mano cuando algo huela mal.",
  "Detrás de cada parte hay un equipo entero.",
  "Lo que el cliente percibe es el conjunto. Cuídalo entero.",
  "El operario tranquilo deja obras tranquilas.",
  "Una camiseta bien puesta dice mucho de quien la lleva.",
  "Hablar bien del compañero te hace mejor a ti.",
  "El que respeta al cliente, respeta su oficio.",
  "Una buena obra deja amigos, no problemas.",
  "Cuanto antes lo digas, antes se resuelve.",
  "Lo que se hace bien, se hace una sola vez.",
  "La calidad no se ve cuando funciona, pero se nota cuando falla.",
  "Las prisas se notan dentro de seis meses.",
  "Una etiqueta clara hoy es una hora ganada mañana.",
  "Comprueba dos veces antes de cerrar.",
  "La perfección no existe, pero el cuidado sí.",
  "Un buen bridado se reconoce sin tocarlo.",
  "El metro y el nivel son tus mejores amigos en el tejado.",
  "Si no estás seguro, mídelo otra vez.",
  "Una conexión apretada es tranquilidad para años.",
  "El detalle pequeño es el que se nota de lejos.",
  "Lo bien hecho no necesita explicación.",
  "Documenta lo que ves. La memoria es mala consejera.",
  "Cada foto del parte vale más que mil palabras.",
  "Si lo dejas torcido hoy, lo arreglas torcido mañana.",
  "Cuando algo no cuadra, no cuadra.",
  "Un tornillo flojo es una llamada de teléfono.",
  "La calidad es la mejor publicidad del taller.",
  "La obra termina cuando se recoge, no cuando se conecta.",
  "Cada cable que cuelga es deuda futura.",
  "Lo invisible también cuenta.",
  "Un instalador limpio deja huella limpia.",
  "La elegancia se nota en el detalle, no en el reloj.",
  "El error de hoy ya no se puede ocultar, pero sí evitar.",
  "El silencio del cliente satisfecho es la mejor calificación.",
  "Lo que ofreces es tu nombre encima de cada panel.",
  "Si el cliente lo mira, debe verlo perfecto.",
  "Una bandeja recta cuesta lo mismo que una torcida.",
  "La nota se la das tú al trabajo, no el cliente.",
  "La calidad cuesta exactamente igual que la prisa.",
  "Cuando algo está bien hecho, dura sin que nadie lo recuerde.",
  "La etiqueta del cable también es trabajo serio.",
  "Una buena foto del parte vale por mil disculpas.",
  "Quien cuida el orden, cuida el oficio.",
  "Cada centímetro mal cortado, vuelve.",
  "Si no se ve, se hace igual de bien.",
  "La diferencia entre amateur y pro está en el remate.",
  "Cuanto más fácil parece, más oficio hay detrás.",
  "Tu firma es la calidad que dejas.",
  "Hoy no te conformes con que funcione. Que dure.",
  "Recoger el sobrante es parte del trabajo, no un extra.",
  "Trabajar limpio es trabajar profesional.",
  "Un panel mal bridado lo paga el siguiente operario.",
  "Lo que se mide se mejora.",
  "Hoy escoge la opción duradera, no la rápida.",
  "El cliente recuerda cómo te despides, no cómo entras.",
  "Un acabado perfecto se nota incluso si nadie lo dice.",
  "Mejor un día más que un cliente menos.",
  "Si lo cierras bien, no vuelves a abrirlo.",
  "La calidad es un hábito, no un esfuerzo.",
  "Hoy es difícil. Por eso vale.",
  "Un mal día también suma experiencia.",
  "Si el viento te molesta, el techo te lo agradecerá luego.",
  "El sudor de hoy es la sonrisa de mañana.",
  "No hay fallo que el café no pueda mitigar.",
  "Cuando algo se complica, baja una marcha, no la guardia.",
  "Las averías más difíciles enseñan más.",
  "El subidón llega después del último tornillo, no antes.",
  "La mejor obra es la que más cuesta.",
  "Llueva o haga sol, el parte se hace.",
  "El error es maestro silencioso.",
  "La paciencia es la mejor herramienta del oficio.",
  "Lo que hoy te cuesta, mañana lo haces dormido.",
  "Cuando el cliente exige, el equipo crece.",
  "La rutina te da seguridad. La novedad te da forma.",
  "Caer no es problema. Quedarse abajo, sí.",
  "Hoy enfréntate a lo que ayer evitaste.",
  "La mejor jornada empieza atándose bien las botas.",
  "Si está difícil, prueba al revés.",
  "La calma resuelve más que la prisa.",
  "Un buen profesional no se enfada con la herramienta.",
  "Cuando algo no va, respira y vuelve a empezar.",
  "La obra te enseña lo que ningún libro.",
  "Los problemas no se llevan a casa.",
  "Hoy gana el que no se rinde antes del último intento.",
  "Quien insiste con cabeza, llega.",
  "Un trabajo difícil te hace mejor profesional.",
  "La frustración es solo experiencia sin digerir.",
  "Caer al primer fallo es renunciar al éxito.",
  "La constancia paga más que el talento.",
  "Lo imposible suele ser solo lo no intentado.",
  "Tu peor jornada te enseña tu mayor lección.",
  "Después del lío, viene la maestría.",
  "Hoy gánate el salario del lunes con creces.",
  "Un nudo bien deshecho enseña más que un cable nuevo.",
  "La templanza es la herramienta sin nombre.",
  "Quien levanta su obra, levanta su orgullo.",
  "La obstinación inteligente vence al cansancio.",
  "La paciencia gana más obras que la velocidad.",
  "Cuando el sol pega, la sombra está cerca.",
  "La adrenalina dura un minuto. El oficio, una vida.",
  "Lo que cuesta, recuerda.",
  "Hay días en que solo aprendes, y eso ya es ganar.",
  "Cuando todo falla, vuelve a los básicos.",
  "Las soluciones aparecen cuando dejas de buscarlas con prisa.",
  "La obra termina, pero el aprendizaje se queda.",
  "La mejor pausa es la que evita un error.",
  "La fatiga no es excusa para una mala instalación.",
  "Quien aguanta el último tramo, gana el día.",
  "Hoy demuestra que sabes hacerlo, no que sabes correr.",
  "Cada parte es un paso. Hoy das uno más.",
  "El profesional de mañana se forja en el parte de hoy.",
  "Tu mejor maestro es el operario más callado del equipo.",
  "Lo que aprendes en una hora puede ahorrarte un día.",
  "Crecer es preguntar lo que no sabes.",
  "Hoy harás algo que el año pasado no sabías hacer.",
  "El oficio se mejora cada jornada, no cada curso.",
  "La mejor versión de ti está a un parte de distancia.",
  "Hoy hazlo un 1% mejor que ayer.",
  "Sumar oficio es sumar libertad.",
  "Cada herramienta nueva, una nueva habilidad.",
  "Crecer no se ve, pero los demás lo notan.",
  "Aprender es trabajar dos veces, con el mismo sueldo.",
  "La curiosidad es el currículum más valioso.",
  "Hoy intenta algo que ayer pediste a otro.",
  "Tu mejor obra siempre es la siguiente.",
  "Mañana querrás haber empezado hoy.",
  "La constancia construye carrera.",
  "Cuanto más sepas, más fácil el día.",
  "La empresa crece con cada operario que crece.",
  "Aprender un truco nuevo es la mejor pausa.",
  "Cada jornada, una habilidad más en tu mochila.",
  "El que escribe lo que aprende, lo guarda dos veces.",
  "Mira al veterano y aprende algo. Mira al joven y enseña algo.",
  "Hoy lleva la libreta. Mañana te dará la razón.",
  "El oficio se hereda contando, no callando.",
  "Pregunta hasta entender. Es gratis.",
  "Cada error documentado es un fallo evitado.",
  "Comparte lo que aprendiste hoy. Mañana lo recordarás.",
  "Hoy puedes ser el aprendiz. Mañana, el referente.",
  "Cuanto antes empieces, antes aprendes.",
  "Crecer es soltar el «siempre se hizo así».",
  "Tu próxima oportunidad sale del trabajo de hoy.",
  "Lo que se enseña, se aprende dos veces.",
  "Un buen profesional pregunta todos los días.",
  "El veterano que comparte deja huella eterna.",
  "Cada parte bien escrito es historia del oficio.",
  "Cuanto mejor cuentas tu día, mejor lo recuerdas.",
  "Hoy hablas con calma, mañana mandas con respeto.",
  "La excelencia es repetir bien lo simple.",
  "Cuanto más cuides los pequeños hábitos, más grande tu progreso.",
  "La rutina inteligente es escalera al éxito.",
  "Las obras grandes son sumas de detalles pequeños.",
  "Hoy no te conformes con cumplir. Mejora algo.",
  "Lo que dejas mejor que ayer es tu legado.",
  "La empresa se eleva con cada operario que aprende.",
  "Lo que el equipo comparte, el equipo gana.",
  "Hoy mira atrás un segundo y reconoce lo aprendido.",
  "La meta de hoy es ser mejor que el operario de ayer.",
  "La mejor obra es la próxima.",
  "Cuanto más amplio tu mundo, mejor tu técnica.",
  "Cada conversación con un colega es un curso gratis.",
  "El detalle aprendido hoy te diferencia mañana.",
  "Hoy aprende a dejar el sitio mejor de cómo lo encontraste.",
  "Un compañero que crece tira de toda la cuadrilla.",
  "Sigue. La carrera no se mide en metros, sino en obras.",
  "Lo que sabes hoy, le sirve a alguien mañana.",
  "El conocimiento bien compartido nunca se gasta.",
  "Hoy aprende, mañana enseña.",
  "Cada año mejor que el anterior. Esa es la meta.",
];

/**
 * Returns the 0-based working-day index of the year (Mon-Fri counted, Sat/Sun skipped).
 * Jan 1st if it's a weekday is index 0, etc.
 */
export function getWorkingDayIndex(date = new Date()) {
  const start = new Date(date.getFullYear(), 0, 1);
  let count = 0;
  const cur = new Date(start);
  while (cur <= date) {
    const d = cur.getDay();
    if (d !== 0 && d !== 6) count++;
    cur.setDate(cur.getDate() + 1);
  }
  return Math.max(0, count - 1);
}

/**
 * Returns the phrase for today, or null on Saturday/Sunday.
 * Different working day -> different phrase. Wraps around if the year has more
 * working days than phrases (rare; we have 260 which exceeds normal ~252).
 */
export function getDailyPhrase(date = new Date()) {
  const d = date.getDay();
  if (d === 0 || d === 6) return null;
  const idx = getWorkingDayIndex(date);
  return DAILY_PHRASES[idx % DAILY_PHRASES.length];
}
